/**
 * Eritrean nakfa.
 */
export var ERN = {
  code: 'ERN',
  base: 10,
  exponent: 2
};